<template>
	<div class="h-100 d-flex flex-column overflow-hidden" v-if="user">
		<Header @logout="$emit('logout')"  :page="page" @changeUser="changeUser" @toggleNav="$refs.Nav.showNav = !$refs.Nav.showNav" />
		<div class="flex-fill d-flex position-relative" style="min-height: 0">
			<!-- <Nav ref="Nav" :page="page" @open="open" /> -->
			<div class="flex-fill d-flex flex-column overflow-hidden ">
				<router-view ref="router" @open="open"  @getCallDetails="getCallDetails"/>
			</div>
		</div>
		<Call v-if="onPhone" :callData="callData" @hangupCall="hangupCall" />
	</div>
</template>

<script>
    import Header from "./subcomponents/Header.vue";
    // import Nav from "./subcomponents/Nav.vue";
	import Call from "./Call.vue";
	import { mapState } from 'vuex'

	export default {
		name: 'Home',
		props: ['page'],
		components: {
			Header,
			// Nav,
			Call 
		},
		computed: {
			...mapState('firebase', ['prospects', 'convos', 'user']),
		},
		methods: {
			foundNum(ClientNumber) {
				let prospect = null;
				for (let temp of this.prospects) {
					if (temp.Number == ClientNumber) { prospect = temp; }
				}
				if (this.folder != "All" && (!prospect || prospect.Tags.length == 0 || !prospect.Tags.includes(this.folder))) { return false; }
				if (ClientNumber.includes(this.search)) { return true; }
				if (!prospect) { return false; }
				return this.$parseAlias(prospect).toLowerCase().includes(this.search.toLowerCase());
			},
			open(target) {
				if (this.$route.path != '/home/Conversations') {
					this.$router.push('/home/Conversations');
					this.$nextTick(() => {
						this.$refs.router.changePage(target);
					})
				} else {
					this.$refs.router.changePage(target);
				}
			},
			foundProsp(prospect) {
				if ((!prospect.Tags || !prospect.Tags.filter(tag => this.user.Folders.indexOf(tag) >= 0).length) && this.folder != "All") { return false; }
				if (this.folder != 'All' && prospect.Tags && prospect.Tags.length > 0 && !prospect.Tags.includes(this.folder)) { return false; }
				return (prospect.Number && prospect.Number.includes(this.search)) || this.$parseAlias(prospect).toLowerCase().includes(this.search.toLowerCase())
			},
			async getProsp(ClientNumber) {
				for (let prospect of this.prospects) {
					if (prospect.Number == ClientNumber)
						return prospect;
				}
				return null;
			},
			changeUser(value) {
				//eslint-disable-next-line
				// console.log(value)
				this.$emit('changeUser',value);
			},
			getCallDetails(value) {
				if (this.onPhone) {
					alert('Another call is in progress');
				}else {
					this.callData = value;
					this.onPhone = value.showCallBox
				}
				// this.$emit('changeUser',value);
			},
			hangupCall(val) {
				this.onPhone = val;
			}
		},
		data() {
			return {
				error: "",
				onPhone: false,
				callData:{}
			}
		}
	}
</script>

<style scoped>
	*{
		padding: 0, 10px;
		margin: 0;
	}
	#Title {
		position: absolute;
		visibility: hidden;
	}
</style>
